<template>
  <v-card
    tile
    height="100vh"
    flat
    color="primary"
    class="applications mx-auto d-flex flex-column justify-center"
    elevation="1"
  >
    <div class="landing--img align-self-center">
      <v-img src="@/assets/images/landing2.png"></v-img>
    </div>
    <div class="align-self-center mx-3 my-3 white--text">
      <h2>WELCOME</h2>
    </div>
    <div
      class="terms--text align-self-center text-center mx-3 my-3 text-wrap white--text"
    >
      Kenya Institute of Supplies Examination Board is a professional
      examination body with the mandate to develop syllabuses, conduct
      examinations for professional supply chain management certification. It
      offers 2 certifications:

      <a
        class="font-weight-bold white--text"
        href="https://kiseb.or.ke/"
        target="_blank"
      >
        CPSP-K
      </a>
      and
      <a
        class="font-weight-bold white--text"
        href="https://kiseb.or.ke/"
        target="_blank"
      >
        APS-K
      </a>
    </div>
    <v-card-actions class="actions--input align-self-center mt-7">
      <v-select
        :items="setupProgrammes"
        solo
        v-model="selectedProgramme"
        :item-text="(item) => item.description"
        :item-value="(item) => item.code"
        label="Make An Application"
        @change="onProgrammeSelection(selectedProgramme)"
      ></v-select>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "Terms",
  data: function () {
    return {
      selectedProgramme: null,
    };
  },
  computed: {
    setupProgrammes() {
      return this.$store.getters["Application/appGetters"]("setupProgrammes");
    },
  },
  methods: {
    encode(value) {
      return btoa(
        JSON.stringify({
          prog: value,
        })
      );
    },
    onProgrammeSelection(programmeCode) {
      localStorage.setItem("programmeCode", programmeCode);
      this.$router.push({
        name: "Signup",
        params: {
          prog: this.encode(programmeCode),
        },
      });
    },
  },
};
</script>
<style scoped>
@import url("../styles.css");
.v-select > .dropdown-menu {
  text-align: center;
}
</style>
